import './AlgorithmPage.scss';

import React from 'react';
import { connect } from 'react-redux';

import { getAlgorithm, putAlgorithm, setAlgorithm } from './store/actions';

import AlgorithmEditModal from './AlgorithmEditModal';
import AlgorithmForm from './AlgorithmForm';
import LoadingCircle from 'components/LoadingCircle';
import PageContent from 'components/PageContent';
import ConfirmModal from 'components/Modal/ConfirmModal';

class AlgorithmPage extends React.Component {
    constructor() {
        super();

        this.originalAlgorithm = null;

        this.state = {
            dataToEdit: {},
            showAlgorithmEditModal: false,
            showConfirmModal: false
        }
    }

    closeEditModal() {
        this.setState({showAlgorithmEditModal: false});
        this.handleResetForm();
    }

    componentWillMount() {
        this.props.getAlgorithm()
            .then((res) => {
                if(res.code === 200) {
                    this.originalAlgorithm = JSON.parse(JSON.stringify(res.data.active));
                    console.log('original', this.originalAlgorithm);
                }
            })
    }

    handleResetForm() {
        this.props.setAlgorithm(JSON.parse(JSON.stringify(this.originalAlgorithm)));
    }

    handleSubmit() {
        this.props.putAlgorithm()
            .then((res) => {
                if(res.code === 200) {
                    this.setState({
                        showAlgorithmEditModal: false,
                        showConfirmModal: true
                    });
                }
            });
    }

    openEditModal(dataToEdit) {
        this.setState({dataToEdit, showAlgorithmEditModal: true});
    }

    render() {
        return (
            <PageContent>
                {this.props.algorithm.isFetching === true ? (
                    <LoadingCircle />
                ) : (
                    <div className="algorithm">
                        <AlgorithmForm
                            algorithm={this.props.algorithm.config}
                            error={this.props.algorithm.error}
                            handleResetForm={this.handleResetForm.bind(this)}
                            isSaving={this.props.algorithm.isSaving}
                            openEditModal={this.openEditModal.bind(this)}
                        />
                    </div>
                )}

                <ConfirmModal
                    confirmOnClick={() => this.setState({showConfirmModal: false})}
                    confirmText="OK"
                    contentLabel="Modal confirming your changes were saved"
                    show={this.state.showConfirmModal}
                    showDeclineButton={false}
                    title="Your changes were successfully saved"
                />

                <AlgorithmEditModal
                    algorithm={this.props.algorithm.config}
                    closeEditModal={this.closeEditModal.bind(this)}
                    dataToEdit={this.state.dataToEdit}
                    defaultAlgorithm={this.props.algorithm.defaultConfig}
                    handleSubmit={this.handleSubmit.bind(this)}
                    isSaving={this.props.algorithm.isSaving}
                    show={this.state.showAlgorithmEditModal === true}
                    setAlgorithm={this.props.setAlgorithm.bind(this)}
                />
            </PageContent>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        algorithm: state.algorithm
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAlgorithm: () => dispatch(getAlgorithm()),
        putAlgorithm: () => dispatch(putAlgorithm()),
        setAlgorithm: (algorithmObj) => dispatch(setAlgorithm(algorithmObj))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AlgorithmPage);



// WEBPACK FOOTER //
// ./src/containers/AlgorithmPage/index.js